import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import { omitUndefined } from "../../utils/lodash.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import { FieldConfig, DEFAULT_VALUES_SHAPE } from "./DTICalculator.utils.esm.js";
import DTIFields from "./DTIFields.esm.js";
import DTIOutputTable from "./DTIOutputTable.esm.js";
const DTICalculator = ({
  defaultValues,
  editorMode
}) => /* @__PURE__ */ jsx(CalculatorForm, { editorMode, fieldStorageKey: "DTIFields", calcTypeForMarketing: "DTI", defaultValues: {
  [FieldConfig.annualIncome.name]: 7e4,
  [FieldConfig.minCreditCardPayments.name]: 200,
  [FieldConfig.carLoanPayments.name]: 500,
  [FieldConfig.studentLoanPayments.name]: 300,
  [FieldConfig.alimonySupportPayments.name]: 0,
  [FieldConfig.secondaryHomeExpenses.name]: 0,
  [FieldConfig.otherDebtPayments.name]: 0,
  ...omitUndefined(defaultValues)
}, children: /* @__PURE__ */ jsxs(Box, { sx: {
  paddingBottom: "$spacing.sm",
  display: "flex",
  flexDirection: "column-reverse",
  "@media $lg": {
    "flex-direction": "row",
    "justify-content": "space-between"
  }
}, children: [
  /* @__PURE__ */ jsx(Box, { sx: {
    flexShrink: 0,
    "@media $md": {
      flexBasis: "30%"
    },
    "@media $lg": {
      marginRight: "$spacing.sm"
    }
  }, children: /* @__PURE__ */ jsx(DTIFields, {}) }),
  /* @__PURE__ */ jsx(Box, { sx: {
    "@media $md": {
      "flex-basis": "65%"
    }
  }, children: /* @__PURE__ */ jsx(DTIOutputTable, {}) })
] }) });
DTICalculator.defaultProps = {
  defaultValues: void 0,
  editorMode: void 0
};
DTICalculator.propTypes = {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
};
export {
  DEFAULT_VALUES_SHAPE,
  DTICalculator as default
};
